import React from 'react';

import {
  ProgramHeader,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import Workouts from './Workouts';

type Props = {
  programId: number,
  resourceType: 'programTemplates' | 'personalPrograms',
};

const ProgramAllWorkouts = ({
  programId,
  resourceType,
}: Props) => (
  <Flex fillSpace column>
    <ProgramHeader
      mode="all"
      readOnly
      programId={programId}
      resourceType={resourceType}
    />
    <Workouts
      resourceType={resourceType}
      programId={programId}
    />
  </Flex>
);

export default ProgramAllWorkouts;
